import * as R from 'ramda';
import React from 'react';

import {translate} from 'iss/strings';
import {Button} from 'iss/widgets/Buttons';
import {Field, FormSection} from 'iss/widgets/Forms';
import {RecurrenceTypeSelector} from 'iss/widgets/Selectors';
import {SelectableContractEditor} from 'iss/widgets/activation/SelectableContractEditor';
import {MonthDayChooser, WeekDayChooser, YearDayChooser} from 'iss/widgets/form/input/DateChoosers';
import validators, {withError} from 'iss/widgets/form/validation/validators';

export function RecurrenceDatesSelector({multi}) {
  const DateSelector = multi ? MultiRecurrenceDatesSelector : RecurrenceDateSelector;
  return <FormSection>
    {(values, formApi) => <React.Fragment>
      <RecurrenceTypeSelector id="recurrenceType" label="evaluationActivator.recurrenceType"
        helpText='batchEvaluationActivator.recurrenceDateHelpText'
        valuePath="recurrenceType"
        onChange={() => {
          formApi.setValue("recurrenceDates", []);
          formApi.setValue("addRecurrenceDates", []);
        }} />
      <DateSelector id="recurrenceDates" valuePath="recurrenceDates" recurrenceType={values.recurrenceType} formApi={formApi} />
    </React.Fragment>}
  </FormSection>;
}

export function MultiRecurrenceDatesSelector({id, valuePath, recurrenceType, ...otherProps}) {
  if (recurrenceType === 'MANUAL') { return null; }
  return <SelectableContractEditor valuePath={valuePath} defaultValue={[]}>
    {({selectedValues, updateSelectedValues, ContractSelectorTable}) =>
      <React.Fragment>
        <div id={id}>
          <RecurrenceDateSelector id="recurrenceDatesToAdd" valuePath="addRecurrenceDates" recurrenceType={recurrenceType} hasLabel={false} validator={[]} {...otherProps} />
          <Button id="clearDates" buttonLook="danger" disabled={R.isEmpty(selectedValues)}
            onClick={() => updateSelectedValues(R.always([]))} >
            {translate('batchEvaluationActivator.clearSelectedDates')}
          </Button>
          <Field valuePath="addRecurrenceDates">
            {datesField =>
                <Button id="addRecurrenceDates" buttonLook="primary" disabled={R.isEmpty(selectedValues) || R.isEmpty(datesField.getValue())}
                  onClick={() => updateSelectedValues(R.always(datesField.getValue()))}>
                  {translate('batchEvaluationActivator.setSelectedDates')}
                </Button>
            }
          </Field>
        </div>
        <ContractSelectorTable id="recurrenceDatesTable"
          columns={[
            {
              header: translate(getRecurrenceDatesLabel(recurrenceType)),
              accessor: (contract) =>
              <RecurrenceDateSelector id={`recurrenceDates-${contract.id}`} valuePath={["recurrenceDates", contract.id]} recurrenceType={recurrenceType} hasLabel={false} {...otherProps}/>
            }
          ]} />
      </React.Fragment>
    }
  </SelectableContractEditor>;
}

function RecurrenceDateSelector({recurrenceType, valuePath, hasLabel, ...otherProps}) {
  const validator = withError("evaluationActivator.chooseEvaluationDates", validators.chooseOne);
  const props = {
    label: hasLabel !== false ? getRecurrenceDatesLabel(recurrenceType) : null,
    multi: true,
    valuePath, validate: validator, ...otherProps
  };

  switch(recurrenceType) {
    case 'WEEKLY':
      return <WeekDayChooser {...props} />;
    case 'MONTHLY':
      return <MonthDayChooser {...props} />;
    case 'CUSTOM_DATES':
      return <YearDayChooser {...props} />;
    case 'MANUAL':
    default:
      return null;
  }
}

function getRecurrenceDatesLabel(recurrenceType) {
  switch(recurrenceType) {
    case 'CUSTOM_DATES':
      return "evaluationActivator.evaluationDates";
    default:
      return "evaluationActivator.evaluationDays";
  }
}

export function toActivationRecurrenceDates({recurrenceType, recurrenceDates}) {
  switch(recurrenceType) {
    case 'WEEKLY':
      return recurrenceDates;
    case 'MONTHLY':
      return recurrenceDates.map(day => ({day, month: null}));
    case 'CUSTOM_DATES':
      return recurrenceDates.map(date => {
        const [day, month] = date.split(".");
        return {day, month};
      });
  }
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/activation/DateSelectorSections.jsx